import React, { useState } from 'react'
import images from "../../../../Utils/importImages";
import { fareOptions } from '../../../../Constants/ConstantsFlights';
import { useDispatch, useSelector } from 'react-redux';
import { searchTheFlightUrlCreator, setTheFareType } from "../../../../Redux/Slices/Flight_Slices/HomePage-Flights-SLICE"
import { useNavigate } from 'react-router-dom';
import SearchModePopup from "../../../Components/Popups/SearchModePopup";
import { formatDateToSeatchParams } from "../../../../Utils/Date_Time_Calendar_Functions";

function SpecialFareOptions({ selectedFareOption, style }) {

  let dispatch = useDispatch();
  const navigate = useNavigate();
  const isAdminLogin = useSelector((state) => state.user.isAdminLogin);
  const searchBarData = useSelector((state) => state.HomePageSearchBarFlight);
  const userState = useSelector((state) => state.user);

  const [showSearchModePopup, setShowSearchModePopup] = useState(false);

  // cacheMinutes (1-10, admin-chosen via SearchModePopup's cache-time step) is optional — a
  // normal customer search never passes it, and searchTheFlightUrlCreator only appends &cm= to
  // the URL when it's actually present.
  const handleSearch = (cacheMinutes) => {
    dispatch(searchTheFlightUrlCreator({ navigate, cacheMinutes }));
  };

  // Admin-only: SEARCH offers a "Direct Search" (real, unchanged flow) vs "Test Search"
  // (debug JSON) choice — see SearchModePopup.jsx. Everyone else keeps the original
  // one-click behavior exactly as before.
  const handleSearchClick = () => {
    if (isAdminLogin) {
      setShowSearchModePopup(true);
    } else {
      handleSearch();
    }
  };

  // The homepage doesn't carry a ready-made Travellers/User/Fare/Segments request body (that
  // only gets built once you land on /flights/results and its URL gets parsed) — so this
  // constructs it fresh from the current homepage state, matching what
  // MainSearchController::search() validates.
  const buildTestSearchParams = () => {
    const { searchBarMode, multiRowNumber, searchParams } = searchBarData;
    const segs = searchParams.Segments;

    const toSegment = (seg, dateField) => ({
      Origin: seg.OriginCode,
      Destination: seg.DestinyCode,
      OriginCountryCode: seg.OriginCountryCode,
      DestinationCountryCode: seg.DestinationCountryCode,
      Date: formatDateToSeatchParams(seg[dateField]),
    });

    let Segments;
    if (searchBarMode === 1) {
      // Oneway
      Segments = [toSegment(segs[0], "OriginDate")];
    } else if (searchBarMode === 2) {
      // Roundway — backend expects 2 segments: outbound + the swapped return leg
      Segments = [
        toSegment(segs[0], "OriginDate"),
        {
          Origin: segs[0].DestinyCode,
          Destination: segs[0].OriginCode,
          OriginCountryCode: segs[0].DestinationCountryCode,
          DestinationCountryCode: segs[0].OriginCountryCode,
          Date: formatDateToSeatchParams(segs[0].ReturnDate),
        },
      ];
    } else {
      // Multiway
      Segments = segs.slice(0, multiRowNumber).map((seg) => toSegment(seg, "OriginDate"));
    }

    return {
      Travellers: {
        Adults: searchBarData.searchParamsTravellers.Adults,
        Childs: searchBarData.searchParamsTravellers.Childs,
        Infrants: searchBarData.searchParamsTravellers.Infrants,
      },
      User: {
        // User.Id is the CUSTOMER context — never the admin's own id. Previously read
        // userLoggedInData.id unconditionally, which holds whoever is actually logged in right
        // now (admin OR customer, same shared state) — so an admin's own search (no specific
        // customer selected) silently sent the admin's own id as BOTH User.Id and AdminId,
        // producing flight_searches rows (and now flight_hold_bookings rows) with identical
        // user_id/admin_id, which is wrong: an admin's own search has no customer attached at
        // all. Null for any admin-logged-in session — isAdminLogin is the same flag AdminId
        // below already gates on.
        Id: isAdminLogin ? null : userState.userLoggedInData?.id ?? null,
        Country: {
          name: userState.UserCurrentLocationData?.name,
          code: userState.UserCurrentLocationData?.code,
          currency: userState.UserCurrentLocationData?.currency,
          dial_code: userState.UserCurrentLocationData?.dial_code,
          // The "Global" region option is just another real pipeline row (its own id, e.g. 16 —
          // see PipelineController::publicList()), not a sentinel, so selectedPipelineId itself
          // is never "x" for it. The backend's Global-mode fan-out only triggers on pipeline_id
          // being missing/"x" — sending the GLOBAL pipeline's own literal id instead silently
          // turns it into a normal (and API-call-less, since that pseudo-pipeline has no
          // pipeline_data) switched-pipeline search. publicList() tags that row with code: null.
          pipeline_id: userState.pipelinesList?.find(
            (pipeline) => String(pipeline.id) === String(userState.selectedPipelineId)
          )?.code === null
            ? "x"
            : (userState.selectedPipelineId ?? "x"),
        },
      },
      Fare: {
        class: searchBarData.searchParamsFare.class,
        type: searchBarData.searchParamsFare.type,
      },
      Segments,
    };
  };

  return (
    <div className="frame-37" style={style}>
      <div className="frame-43">
        <div className="fare-type proxima_regular color_light-gray-black font15">
          Fare Type
        </div>
        <div className="frame-205">
          <div className="frame-47">
            <div className="frame-205-1 frame-205-44">
              {
                fareOptions.map((item, index) => {
                  return (
                    <div className="frame-42" key={index}
                      onClick={() => dispatch(setTheFareType(item))}
                    >
                      <div className="frame-103-10">
                        <div className={`special-fares ${selectedFareOption === item ? "proxima_regular color_endeavour font14" : "proxima_regular color_eerie-black font14"}`}>
                          {item}
                        </div>
                        <div className={`fares ${selectedFareOption === item ? "proxima_regular color_endeavour font12" : "proxima_regular color_eerie-black font12"}`}>
                          Fares
                        </div>
                      </div>
                      {selectedFareOption === item && <img className="check" src={images['check-4.svg']} alt="check" />}
                    </div>

                  )
                })
              }

            </div>
          </div>
        </div>
      </div>
      <div
        className="frame-44"
        onClick={userState.userLoading ? undefined : handleSearchClick}
        style={
          userState.userLoading
            ? { opacity: 0.6, cursor: "not-allowed", pointerEvents: "none" }
            : undefined
        }
      >
        <div className="search">{userState.userLoading ? "LOGGING IN..." : "SEARCH"}</div>
      </div>

      {showSearchModePopup && (
        <SearchModePopup
          onClose={() => setShowSearchModePopup(false)}
          onDirectSearch={handleSearch}
          buildParams={buildTestSearchParams}
        />
      )}
    </div>
  )
}

export default SpecialFareOptions
